const wowApp = require('angular').module('oly.common');

wowApp.factory('MoveFocus', ['$timeout', '$q', require('./movefocus-factory')]);

wowApp.directive('olyMoveFocus', ['MoveFocus', require('./movefocus.directive')]);

wowApp.directive('olyMoveFocusOndelete', ['MoveFocus', require('./movefocus-afterdelete.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/movefocus/index.js